'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MediaList = require('react-bootstrap/lib/MediaList');

var _MediaList2 = _interopRequireDefault(_MediaList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MediaList2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/MediaList.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/MediaList.js
 ** module chunks = 0
 **/